import { BRANDS } from '../common';
import { APP_IDS } from '../const';

export const getAppId = (brandName, isMobile) => {
  if (brandName === BRANDS.cupis) {
    return isMobile ? APP_IDS.CupisMobile : APP_IDS.CupisDesktop;
  }

  return isMobile ? APP_IDS.ComMobile : APP_IDS.ComDesktop;
};
